import { Component, OnInit, ViewChild } from "@angular/core";
import {
	DatatableComponent,
	ColumnMode,
	SelectionType,
} from "@swimlane/ngx-datatable";
import { SistemaService } from "@core/services/sistema.service";
import Swal from "sweetalert2";

import { Subject } from "rxjs";
import { AuthenticationService } from "app/auth/service";
import { Router } from "@angular/router";

@Component({
	selector: "app-listar-sistema",
	templateUrl: "./listar-sistema.component.html",
	styleUrls: ["./listar-sistema.component.scss"],
})
export class ListarSistemaComponent implements OnInit {
	// Private
	private _unsubscribeAll: Subject<any>;
	private tempData = [];
	public array_status = [
		{
			status: "Ativo",
			id: 0,
		},
		{
			status: "Inativo",
			id: 1,
		},
	];

	// public
	public starting: boolean = false;
	public contentHeader: object;
	public basicSelectedOption: number = 10;
	public ColumnMode = ColumnMode;

	public rows = [];
	temp = [];

	constructor(private sistemaService: SistemaService) {
		this._unsubscribeAll = new Subject();
	}

	@ViewChild(DatatableComponent) table: DatatableComponent;
	@ViewChild("tableRowDetails") tableRowDetails: any;
	ngOnInit(): void {
		this.starting = true;
		this.sistemaService.get().subscribe(
			(res) => {
				(this.rows = res), (this.temp = res), (this.tempData = this.rows);
				this.starting = false;
			},
			(error) => {
				console.log(error);
				this.starting = false;
			}
		);

		this.contentHeader = {
			headerTitle: "Sistemas",
			actionButton: false,
			breadcrumb: {
				type: "",
				links: [
					{
						name: "Início",
						isLink: false,
					},
					{
						name: "Sistema",
						isLink: false,
					},
				],
			},
		};
	}

	ngAfterContentChecked() {
		this.rows = [...this.rows];
	}

	public msgConfirmacao(data) {
		Swal.fire({
			title: "Confirmação",
			text: "Deseja mesmo excluir?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Excluir",
			cancelButtonText: "Cancelar",
			customClass: {
				confirmButton: "btn btn-danger",
				cancelButton: "btn btn-primary ml-1",
			},
		}).then((result) => {
			if (result.isConfirmed) {
				this.indicadorDelete(data);
			}
		});
	}

	public indicadorDelete(id: number) {
		return this.sistemaService.delete(1, id).subscribe(
			(res) => {
				Swal.fire({
					title: "Sucesso!",
					text: "O item foi excluído.",
					icon: "success",
					confirmButtonText: "Confirmar",
				}).then((result) => {
					if (result.isConfirmed) {
						this.sistemaService.get().subscribe(
							(res) => (this.rows = res),
							(error) => error
						);
					}
				});
			},
			(error) => {
				Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
			}
		);
	}

	updateFilter(event) {
		const val = event.target.value.toLowerCase();

		// filter our data
		const temp = this.temp.filter(function (d) {
			return d.campanha.toLowerCase().indexOf(val) !== -1 || !val;
		});

		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	public getNomeStatus(event) {
		for (let index = 0; index < this.array_status.length; index++) {
			if (event == this.array_status[index].id) {
				return this.array_status[index].status;
			}
		}
	}
}
